<template>
  <div class="tinymce-container editor-container">
    <textarea
      :id="id"
      class="tinymce-textarea"
    ></textarea>
  </div>
</template>
<script>
import axios from '@/http.js';
//import axios from 'axios'
import { Loading } from 'element-ui'
export default {
  name: 'Tinymce',
  data() {
    return {
      hasChange: false,
      hasInit: false,
      loadingInstance: '' // 全局加载中
    }
  },
  props: {
    id: {
      type: String,
      default: 'tinymceEditor'
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return [
          'joinfimage'
        ]

        //code | undo redo | bold italic underline strikethrough removeformat | forecolor backcolor | styleselect formatselect fontselect fontsizeselect | alignleft aligncenter alignright alignjustify outdent indent | separator link joinfimage | table
        //     code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
        // styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
        // table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs
      }
    },
    height: {
      type: Number,
      required: false,
      default: 400
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>{
          tinymce.get(this.id).setContent(val)
        })
      }
      this.$nextTick(() =>{
          //window.MathJax.typesetPromise([tinymce.get(this.id).contentDocument.body])
        })
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const _this = this
      tinymce.init({
        selector: `#${this.id}`,
        language: 'zh_CN',
        height: this.height,
        body_class: 'panel-body',
        object_resizing: true,
        toolbar: this.toolbar,
        menubar: false,
        statusbar: false,
        valid_elements: '*[*]', // 解决标签被过滤问题（有效元素）
        valid_children: '*[*]', // 解决标签被过滤问题（有效子元素）
        extended_valid_elements: 'style,link[href|rel],script,script[src],a[href|class|target|onclick]', // 解决标签被过滤问题（扩展有效元素）
        custom_elements: 'style,link,~link,script,a[onclick],script[src]', //  解决标签被过滤问题
        font_formats:
          '微软雅黑=微软雅黑,Microsoft YaHei;宋体=宋体,SimSun;黑体=黑体, SimHei;隶书=隶书, SimLi;楷体=楷体,楷体_GB2312, SimKai;andale mono=andale mono;arial=arial, helvetica,sans-serif;arial black=arial black,avant garde;comic sans ms=comic sans ms;impact=impact,chicago;Arial=Arial;Verdana=Verdana;Georgia=Georgia;Times New Roman=Times New Roman;Trebuchet MS=Trebuchet MS;Courier New=Courier New;Impact=Impact;Comic Sans MS=Comic Sans MS;Calibri=Calibri',
       images_upload_url:axios.defaults.baseURL+"/comm/uploadfile",
       automatic_uploads: false,
        images_upload_credentials:true,
        imagetools_cors_hosts: ['www.tinymce.com','codepen.io'],
        plugins: [
          'advlist autolink lists link image preview anchor powerpaste',
          'searchreplace visualblocks code fullscreen',
          'charmap colorpicker directionality emoticons nonbreaking',
          'tabfocus textcolor joinfimage table'
        ],
        // paste_as_text:true, // 此选项控制“粘贴为文本”菜单项的默认状态，该状态由powerpaste插件在Edit菜单下拉菜单中添加
        powerpaste_word_import: 'clean', // 参数可以是propmt, merge, clear，效果自行切换对比
        powerpaste_html_import: 'clean', // propmt, merge, clear  https://www.tiny.cloud/docs/plugins/powerpaste/
        powerpaste_allow_local_images: true,
        paste_data_images: true,
        paste_webkit_styles: true, // 禁止自动去除标签测试（无用）
        images_upload_handler: function(blobInfo,success,failure) {
          const fd = new FormData()
          fd.append('file',blobInfo.blob())
          axios.post("/comm/uploadfile",fd)
            .then((res) => {
              if(res.data.status==0){
                success(res.data.data.showUrl)
              }
              else{
                this.$message(res.data.msg);
              }

            }).catch((e) => {
              console.log('fd',e)
            })
        },
        file_picker_callback: function(callback, value, meta) {
          console.log(callback,value,meta)
        },
        fontsizeFormats:  '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 24pt 36pt 48pt',
        default_link_target: '_blank',
        link_title: false,
        init_instance_callback: editor => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('NodeChange Change KeyUp',() => {
            this.hasChange = true
            this.$emit('input',editor.getContent({ format: 'raw' }))
          })
        },
        setup(editor) {
          editor.addButton('h2',{
            title: '小标题', // tooltip text seen on mouseover
            text: '小标题',
            onclick() {
              editor.execCommand('mceToggleFormat',false,'h2')
            },
            onPostRender() {
              const btn = this
              editor.on('init',() => {
                editor.formatter.formatChanged('h2',state => {
                  btn.active(state)
                })
              })
            }
          })
          editor.addButton('p',{
            title: '正文',
            text: '正文',
            onclick() {
              editor.execCommand('mceToggleFormat',false,'p')
            },
            onPostRender() {
              const btn = this
              editor.on('init',() => {
                editor.formatter.formatChanged('p',state => {
                  btn.active(state)
                })
              })
            }
          })
          editor.on('joinimageuploadstart',function(e) {
            _this.$message({ duration: 0,message: '正在上传图片...' })
            _this.loadingInstance = Loading.service({
              lock: true,
              test: '上传中...'
            })
          })
          editor.on('joinimageuploadend',function(e) {
            _this.loadingInstance.close()
            _this.$message.closeAll()
          })
          editor.on('joinimageuploaderror',function(e) {
            _this.loadingInstance.close()
            if (e && e.errMsg) {
              _this.$message({ duration: 3000,message: e.errMsg })
            }
          })
        }
      })
    },
    getContent() {
      return tinymce.get(this.id).getContent()
    },
    /**
     * 设置内容
     */
    setContent(data) {
      //tinymce.activeEditor.setContent(data)
      //console.log(1111,tinymce.get(this.id))
      tinymce.get(this.id).setContent(data)
      setTimeout(()=>{     
         window.MathJax.typesetPromise([tinymce.get(this.id).contentDocument.body])
        },500)

      // this.$nextTick(() =>{
      //     window.MathJax.typesetPromise([tinymce.get(this.id).contentDocument.body])
      // })
    }

  },
  destroyed() {
    if (tinymce.get(this.id) && tinymce.get(this.id).destroy) {
      tinymce.get(this.id).destroy()
    }
  }
}

</script>
<style scoped>
.tinymce-container {
  position: relative;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 15px;
  top: 18px;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
